import { gustoLuxeBrandId, vacBrandId } from '../../../config';
import GustoLuxeHubStyle from './GustoLuxeHubStyle';
import VacHubStyle from './VacHubStyle';

export const HubBrandStyle = ({ brandId }: { brandId: string }) => {
  if (brandId === vacBrandId) return <VacHubStyle />;
  if (brandId === gustoLuxeBrandId) return <GustoLuxeHubStyle />;
  return null;
};
